import styled from 'styled-components';
const ContentMinHeightDiv = styled('div') `
  min-height: 20rem
`;
export default ContentMinHeightDiv;
